let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l1ol4")).then(() => parcelRequire('v17He'));